module.exports = __webpack_public_path__ + "media/images/ranking_banner-5b78f887214af8747bb492586706c69d.jpg";